import { areCybusDeviatedServiceEquals, Capability } from '../../../../../../domain'

import type { PageSubscriptionsTypes } from '../../../../../../application'

import { BaseDeviatedServicesStrategy, type DeviatedServiceResponse, type DeviatedServicesPageSortableColumnsMap } from './BaseDeviatedService'

export class DeviatedServicesStrategy extends BaseDeviatedServicesStrategy<'deviatedServices'> {
    protected override deviationsSupportedType = 'deviatedServices' as const

    protected override errorMessage = 'Could not fetch deviated services'

    protected override sortingColumns: DeviatedServicesPageSortableColumnsMap<'deviatedServices'> = {
        id: 'serviceId',
        name: null,
        version: null,
        resourceDeviationsCount: null,
    }

    protected override readonly areEquals = areCybusDeviatedServiceEquals

    protected override mapToDomain ({ serviceId, count }: DeviatedServiceResponse): Promise<PageSubscriptionsTypes['deviatedServices']> {
        return this.request<'/api/v2/services/+', 'GET', PageSubscriptionsTypes['deviatedServices']>({
            path: '/api/v2/services/+',
            method: 'GET',
            capability: Capability.DEVIATIONS_READ,
            authenticate: true,
            pathParams: [serviceId],
            handlers: {
                200: (response) => response.getJson().then(({ data: { name, version } }) => ({ id: serviceId, name, version, resourceDeviationsCount: count })),
                404: DeviatedServicesStrategy.createNotFoundErrorHandler('/api/v2/services/+', serviceId),
                500: DeviatedServicesStrategy.createServerErrorHandler(this.errorMessage, { serviceId }),
            },
        })
    }
}
